import FilterComponent from 'components/shared/LogFilters'
import React, { useEffect, useState } from 'react'
import LogDataTable from './LogDataTable'
import { PAGE_LIMIT } from 'helpers/viewContent';
import { getAdminLogData_ } from 'store/services/dashboardService';
import { connect, useDispatch } from 'react-redux';

const ApiLogs = ({ dispatch }) => {
    const [logData, setLogData] = useState({});
    const [totalCount, setTotalCount] = useState(0);

    const [tableFilter, setTableFilter] = useState({
        page: 1,
        limit: PAGE_LIMIT,
        ip: "",
        statusCode: "",
        method: "",
        endpoint: "",
        startDate: "",
        endDate: "",
        search: ""
    });

    const fetchLogData = async () => {
        try {
            let query = {
                ...tableFilter
            };
            let res = await dispatch(getAdminLogData_(query));
            setTotalCount(res?.data?.data?.totalCount);
            setLogData(res?.data?.data);
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        fetchLogData();
    }, [tableFilter])

    const handleDataChange = (key, value) => {
        setTableFilter((prevFilters) => ({
            ...prevFilters,
            [key]: value,
        }));
    };

    const clearFilters = () => {
        setTableFilter({
            ...tableFilter,
            ip: "",
            statusCode: "",
            method: "",
            endpoint: "",
            startDate: "",
            endDate: "",
            search: ""
        });
    };
    return (
        <>
            <FilterComponent
                filter={tableFilter}
                onChange={(e) => handleDataChange(e.target.name, e.target.value)}
                onClear={clearFilters}
            />
            <LogDataTable
                logData={logData?.apiLogsList}
                setFilter={setTableFilter}
                filter={tableFilter}
                totalCount={totalCount}
            /></>
    )
}

const mapStateToPros = (state) => {
    return {
    };
};
function mapDispatchToProps(dispatch) {
    return { dispatch };
}

export default connect(
    mapStateToPros,
    mapDispatchToProps
)(ApiLogs);
